import React from 'react';
import { Avatar } from '@saleshandy/design-system';
import { DoNotCallListPhoneNumber } from '../../../../../../../types/do-not-call-list';

type IProps = {
  phoneNumber: DoNotCallListPhoneNumber;
};

const AddedByField: React.FC<IProps> = ({ phoneNumber: { createdBy } }) => {
  const firstName = createdBy?.firstName || '';
  const lastName = createdBy?.lastName || '';
  const fullName = `${firstName} ${lastName}`.trim();
  return (
    <div className="added-by-field d-flex align-items-center">
      <Avatar firstName={firstName} lastName={lastName} />
      <p className="ml-2">{fullName}</p>
    </div>
  );
};

export default AddedByField;
